import { useMemo, useState } from "react";
import { Table } from "reactstrap";
import { StatusExecucaoEquipeEnum } from "services/OrdemServicoService";

export default function Execucoes({ os }) {
  const [todos, setTodos] = useState(false)

  const execucoes = useMemo(() => {
    const lista = os?.execucoes || []
    if (todos) return lista

    const statusAtivos = [
      StatusExecucaoEquipeEnum.AGUARDANDO_EXECUCAO,
      StatusExecucaoEquipeEnum.EM_EXECUCAO,
      StatusExecucaoEquipeEnum.PAUSADA
    ]

    return lista.filter(ex => statusAtivos.includes(ex.status))
  }, [os, todos])

  return (
    <div>
      <div className="d-flex justify-content-end align-items-center mb-3 gap-5px">
        <div>Todos</div>
        <label className="custom-toggle" style={{ marginBottom: 0 }}>
          <input type="checkbox" checked={todos} onChange={e => setTodos(e.target.checked)} />
          <span className="custom-toggle-slider rounded-circle" />
        </label>
      </div>

      <Table className="align-items-center table-flush">
        <thead>
          <tr>
            <th>Equipe</th>
            <th>Data Prevista Inicio</th>
            <th>Status</th>
            <th>Itens</th>
          </tr>
        </thead>
        <tbody>
          {execucoes.length == 0 ? (
            <tr>
              <td colSpan={4} className="text-center">Nenhuma atribuição encontrada</td>
            </tr>
          ) : (
            execucoes.map(ex => (
              <tr key={ex.id}>
                <td>{ex.equipe}</td>
                <td>{ex.dataFmt}</td>
                <td>{ex.statusFmt}</td>
                <td style={{ whiteSpace: 'normal', overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                  {ex.itens.map((item, idx) => (
                    <div key={`${ex.id}-${idx}`}>{item.codigo} - {item.descricao}</div>
                  ))}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  )
}
